import { RENT_IN_PROGRESS, RENT_RETURN_PENDING } from "./consignmentStates"

export const TEXT_LABELS = {
   EDIT_RENTAL: 'Edit Rental',
   RENTAL_SHIPPED_MSG: 'Your rental was shipped',
   END_DATE: 'End date',
   START_DATE: 'Start date',
   CURRENT_END_DATE: 'Current end date',
   CURRENT_START_DATE: 'Current start date',
   NEW_END_DATE: 'New end date',
   NEW_START_DATE: 'New start date',
   PURCHASE_SHIPPED_MSG: 'Your obligation for fulfillment is complete',
   RENTAL_START_DATE: 'Rental start date',
   RENTAL_END_DATE: 'Rental end date',
   NEW_DELIVERY_DATE: 'New {SHIPPING_TYPE} date',
   NEW_RENTAL_DATES: 'Provide new rental dates',
   RENTAL_MODIFICATOION_REASON: 'Indicate the reason for rental modification',
   PROCESSING_PAYMENT: 'Processing payment',
   PLEASE_WAIT_FOR_A_MINUTE: 'Please wait, this can take up to a minute.',
   RENTAL_COMPLETED: 'Your rental has been completed',
   ORDER_UPDATED_SUCCESSFULLY: 'The order state is updated successfully.',
   PLEASE_WAIT: 'Please wait...',
   RENTAL_DETAILS: 'Rental details',
   MODIFY_RENTAL: 'Modify rental',
   RENTAL_MODIFICATION: 'Rental modification',
   RENTAL_PERIOD_FINISHED: 'Rental period finished',
   OPEN_DISPUTE: 'Open dispute',
   RETRY_PAYMENT: 'Retry payment',
   CONFIRM_RENTAL_COMPLETION: 'Confirm rental completion',
   RENT_DATES_MODIFIED: 'Rent dates were modified',
   RENT_MODIFIED_BY_CUSTOMER: 'The rent was modified by customer from their account on the website',
   PREVIOUS_RENT_DATES: 'Previous rent dates:',
   NEW_RENT_DATES: 'New dates:',
   RENT_DATES: 'Rent dates:',
   NEW_RENTAL_DATES_LABEL: 'New rent dates:',
   EDT_CHANGES: 'Edit changes',
   CONFIRM_CHANGES: 'Confirm changes',
   REJECT_CHANGES: 'Reject changes',
   RENT_WAS_MODIFIED: 'Rent was modified',
   RENT_MODIFICATION_REASON: 'Reason for rental modification:',
   NO_RENT_MODIFICATION_REASON: 'No reason provided.',
   RENT_WAS_MODIFIED_DETAILS: 'Rent modifications were sent to customer. If customer approves modifications via website, order will be modified automatically. If changes were agreed with customer by different means, please confirm modifications below, or reject changes.',
   RENT_MODIFIED_BY_CUSTOMER_ON_HOLD: 'The rent was modified by customer from their account on the website',
   RENT_MODIFIED_BY_VENDOR_ON_HOLD: 'The rent was modified by vendor',
   CONFIRM_MODIFICATION: 'Confirm modification',
   FORCE_OVERRIDE: 'Force override approval',
   REVERT_CHANGES: 'Revert changes',
   TICKET_OPENED_BY_CUSTOMER: 'Ticket is opened by customer',
   TICEKT_RESOLUTION_BY_VENDOR: 'Ticket resolution sent to the customer',
   CUSTOMER_OPENED_TICKET: 'Customer opened the ticket from the account on the website',
   VENDOR_RESOLUTION_SUBMITTED: 'Awaiting Customer Action on Resolution',
   REJECTION_REASON_LABEL: 'Rejection Reason',
   REJECTION_REASON_PLACEHOLDER: 'Select a rejection reason',
   SELECT_OPTION_DEFAULT: 'Select option',
   SELECT_OPTION_PLACEHOLDER: 'Please select an option',
   CANCELLATION_APPROVAL_TITLE: 'Move for Cancellation Approval',
   AUTO_CANCEL_SALESORDER: 'Cancel Consignment',
   CANCELLATION_APPROVAL_MESSAGE_1: 'By clicking Send for Approval, this consignment will move to Cancellation Approval if separate Sales Order items exist in the ERP. Approval is required because those items must be closed before the consignment can be cancelled.',
   CANCELLATION_APPROVAL_MESSAGE_2: 'If no separate Sales Order items exist, approval will not be needed and the consignment will be cancelled directly.',
   SEND_FOR_APPROVAL: 'Send for Approval',
   CANCEL_ORDER_AND_SO: 'Confirm',
   REJECTION_REASON_REQUIRED: 'Rejection reason is required.',
   TICKET_REASON: 'Ticket reason:',
   RESOLVE_TICKET: 'Resolve ticket',
   ATTACHMENTS: 'Attachments',
   RESOLVE_TICKET_DESCRIPTION: 'You can propose other conditions for resolving the ticket by making adjustment to rental dates. You can also leave a comment to customer for clarification.',
   ADD_INFO: 'Add information for your client',
   OPTIONAL: '(optional)',
   ATTACH_DOCUMENTS: 'Attach set of documents',
   DOCUMENTS: 'Documents',
   DOCUMENTS_FROM_CUSTOMER: 'From customer',
   DOCUMENTS_FOR_CUSTOMER: 'For customer',
   RENTAL_UPDATE: 'Rental update',
   ESTIMATED_DELIVERY: 'Est. ship date',
   ESTIMATED_PICKUP: 'Est. pickup',
   READY_FOR_PICKUP: 'Ready for Pickup',
   EDIT: 'Edit',
   INVALID_FILE_TYPE: 'Unsupported file type provided.',
   RENT_MEASUREMENT_UNIT_INFO: 'This order contains rental rates based on units of measurement. Rental pricing can be viewed under each rental item in the \'Rental Rates\' section.',
   ORDER_COMPLIANCE_PROCESSING: 'This processing can take a few days, you will be notified of the status update by email.',
   ORDER_COMPLIANCE_CHECK: 'The order is in OFMP compliance check status',
   PLANNED_USAGE: 'Planned usage',
   APPROVED: 'Approved',
   DECLINE_CUSTOMER_MODIFICATION: 'Decline customer modification',
   RENT_MODIFICATION_WARNING: 'Once the order is modified, it will be sent to the customer for approval. If approved, the payment will be triggered automatically. Prices may be adjusted after modification based on the applicable price books.',
   START_DATE_INVALID: 'Start date cannot be later than end date',
   BLANK_FIELD: 'Field cannot be blank',
   SUBMITTED_BY_CUSTOMER: 'Submitted by customer',
   ORIGINAL_ORDER: 'Original Order',
   SUBMITTED_BY_VENDOR: 'Submitted by vendor',
   SUBMITTED_FOR_APPROVAL: 'Submitted for approval',
   ORDER_STATE_UPDATE: 'Order is being updated. Please wait.',
   MODIFIED_ORDER: 'Modified order',
   SHIPPING: 'Shipping',
   PICKUP: 'Pickup',
   AUTOMATED_CC_ENABLED: 'Automated credit checks enabled.',
   PLEASE_PROVIDE_MDM_NUMBER: "Please provide your company's MDM number (ERP system ID)",
   ENABLE_AUTOMATED_CC: 'Enable Automatic Credit Check',
   MDM_MANAGED_MANUALLY: "This customer’s company credit is currently managed manually within Seller Hub.",
   SUBSCRIPTION_DETAILS: 'Subscription details',
   MODIFY_CANCEL_SUBSCRIPTION: 'Modify / Cancel Subscription',
   PROCESSING: 'Processing...',
   UNEXPECTED_ERROR: 'An unexpected error occurred',
   SO_WONT_CREATE_AUTOMATICALLY: 'As a result, sales orders will not be created automatically.',
   WOULD_YOU_LIKE_TO_ENABLE_AUTOMATED_CC: 'Would you like to enable automatic credit checks instead?',
   MDM_NUMBER_REQUIRED: '(An MDM number is required to proceed)',
   MDM_NUMBER_ADDED: 'Your MDM number has been added successfully.',
   INVALID_MDM_NUMBER: 'Invalid MDM number',
   VERIFY_MDM_NUMBER: 'Please verify the MDM number before proceeding.',

   // Credit Check Banner Labels
   DECLINE_ORDER: 'Decline order',
   SETUP_COMPANY_RELATIONS: 'Set up company relations',
   OVERRIDE_CREDIT_DEFICIT_ACCEPT_ORDER: 'Override credit deficit & Create order',
   RAISE_COMPANY_CREDIT: "Raise company's credit",
   AUTOMATION_FOUND_NO_CREDIT: 'Automation found no credit',
   AUTOMATION_FOUND_INSUFFICIENT_CREDIT: 'Automation found insufficient credit',
   SETUP_REQUIRED: 'Setup required.',
   RECHECK_CREDIT: 'Recheck credit',
   CREDIT_SETTINGS: 'Credit Settings',

   STOCK_INSUFFICIENT_MANUAL_ERROR: 'Please complete manual configuration. Sales order will not be created.',

   // Stock API Error Banner
   STOCK_API_ERROR_TITLE: 'Stock API Error',
   STOCK_API_ERROR_TEXT: 'We were unable to retrieve your inventory levels due to a Stock API issue.',
   STOCK_API_ERROR_TEXT1: 'Please enter the correct stock levels manually. Automated sales order creation is disabled for this order.',
   STOCK_API_ERROR_TEXT2: 'You can try again or proceed manually.',

   // Cancellation Banner Labels
   CANCELATION_TITLE: 'Cancellation approval pending',
   CANCELATION_APPROVAL_TEXT: 'This consignment is in Cancellation Approval. Before approving, close all related ERP Sales Order items. Once they\'re closed, click Approve to cancel the consignment. If any items remain open, the cancellation cannot be completed. Click Reject to keep it active.',
   CANCELATION_FAILED_TEXT: 'Cancellation failed for this consignment. Please review and close all related ERP Sales Order items. Once they\'re closed, click Retry cancellation to cancel the consignment. If any items remain open, the cancellation cannot be completed. Click Reject to proceed with regular fulfillment flow.',
   RETRY_CANCELATION: 'Retry Cancellation',
   REJECT_CANCELATION: 'Reject Cancellation',
   APPROVE_CANCELATION: 'Approve Cancellation',
   STOCK_MANUAL_CONFIRM_LABEL: 'I confirm that I will enter stock levels manually.',

   // Sales Order Error Banner
   SALES_ORDER_ERROR_TITLE: 'Sales order API failed',
   SALES_ORDER_ERROR_TEXT: 'Automatic sales order creation failed. This sales order needs to be handled manually.',
   RETRY_BUTTON_TEXT: 'Retry',
   RECHECKING_BUTTON_TEXT: 'Rechecking',

   // Subscription Modification Modal
   SUBSCRIPTION_MODIFICATION: 'Subscription modification',
   SUBSCRIPTION_START_DATE: 'Subscription Start date',
   SUBSCRIPTION_END_DATE: 'Subscription End date',
   SUBSCRIPTION_MODIFICATION_REASON: 'Indicate the reason for modification (Optional)',
   SUBSCRIPTION_END_DATE_ERROR: 'End date cannot be earlier than the current end date',
   MODIFY_SUBSCRIPTION: 'Modify Subscription',
   CANCEL_SUBSCRIPTION: 'Cancel Subscription',
   SUBSCRIPTION_MODAL_CLOSE: 'Close',
   SUBSCRIPTION_MODAL_MODIFY: 'Modify',

   // Cancel Subscription Modal
   CANCEL_SUBSCRIPTION_TITLE: 'Cancel Subscription',
   CANCEL_SUBSCRIPTION_WARNING: 'Are you sure you want to cancel this subscription?\nThe subscription will remain active until its end date and will not renew after that.\nThe customer will be notified about this cancellation via email.',
   CANCEL_SUBSCRIPTION_REASON: 'Indicate the reason for cancellation',
   CANCEL_SUBSCRIPTION_CONFIRM: 'Confirm cancelation',
   SUBSCRIPTION_CANCELLATION_SCHEDULED_INFO: 'This subscription has been cancelled. It will remain active until {END_DATE} and will not renew after that.',
   SUBSCRIPTION_CANCELLATION_REASON_LABEL: 'Cancellation reason:',

   // Affiliate Program
   AFFILIATE_PROGRAM_DETAILS: 'Affiliate program details',
   DEACTIVATE_AFFILIATE: 'Deactivate Affiliate',
   AFFIIATE_FORM_SUBMITTED: 'Affiliate form submitted',

   // Deactivate Affiliate Modal
   DEACTIVATE_AFFILIATE_TITLE: 'Deactivate Affiliate',
   DEACTIVATE_AFFILIATE_WARNING: 'Are you sure you want to terminate this affiliate?\n The affiliate will lose access to the program and will no longer be able to earn new commission. Any unpaid balance will remain available in the system until it is settled. The affiliate will be notified about this change via email.',
   DEACTIVATE_AFFILIATE_REASON: 'Indicate the reason for deactivation',
   DEACTIVATE_AFFILIATE_CONFIRM: 'Deactivate Affiliate',

   // Edit order
   EDIT_ORDER: 'Edit order',
   ORDER_SYNC_PENDING: 'This edit order are being applied. Actions will be available once the update completes.',
   EDIT_ORDER_SUBTITLE: 'Search and add catalog items or manage all items in this order.',
   BACK_TO_ORDER_DETAILS: 'Back to order details',
   LOOKUP_CATALOG_ITEM: 'Look up catalog item',
   ITEM_ID_SKU: 'SKU',
   LOOKUP: 'Lookup',
   LOOKUP_HELPER_TEXT: 'Enter an SKU to search for items in the catalog.',
   ITEMS_IN_THIS_ORDER: 'Items in this order',
   ITEMS_IN_THIS_ORDER_SUBTITLE: 'Review and manage order items below. Add new items, update details, or remove items as needed. Click "Apply changes" to recalculate totals.',
   ORDER_ITEM_TAG: 'Order item',
   ADDITION_TO_ORDER_TAG: 'Addition to order',
   REMOVAL_FROM_ORDER_TAG: 'Removal from order',
   UPDATED_ITEM_TAG: 'Updated',
   RESTORE: 'Restore',
   OPTIONAL_COMMENT: 'Optional comment',
   REMOVE: 'Remove',
   ORDER_TOTAL: 'Order total',
   APPLY_CHANGES: 'Apply changes',
   APPLY_CHANGES_HINT: 'Recalculate order totals and update the cart.',
   SEND_FOR_APPROVAL_ACTION: 'Send for approval',
   SEND_FOR_APPROVAL_HINT: 'Apply changes to enable',
   RECALCULATING_ORDER_TOTALS: 'Recalculating order totals',
   RECALCULATING_ORDER_TOTALS_MESSAGE: 'Please wait while the updated order is emulated in Hybris.',
   RECALCULATING_ORDER_TOTALS_WARNING: 'Do not close this screen.',
   ORDER_RECALCULATION_FAILED: 'Order recalculation failed. Please review your changes and try again.',
   CHANGES_NOT_SENT_WARNING: 'Your changes have not been sent for approval. If you leave this screen, the current edit session will be discarded.',
   BUYER_NOTIFIED_HINT: 'The buyer will be notified for approval.',
   WITHDRAW_APPROVAL_REQUEST_HINT: 'Withdrawing the request will remove the changes from this order and return you to the order details.',
   CANCEL: 'Cancel',
   PRODUCT: 'Product',
   QUANTITY: 'Quantity',
   ACTION: 'Action',
   UNIT_PRICE: 'Unit price',
   SUBTOTAL: 'Subtotal',
   SEARCH_RESULTS: 'Search results',
   ADD: 'Add',
   ITEM_ID_SKU_REQUIRED: 'SKU is required.',
   CATALOG_ITEM_NOT_FOUND: 'Catalog item not found.',
   CATALOG_ITEM_LOOKUP_FAILED: 'Catalog item lookup failed. Please try again.',
   ITEM_ALREADY_ADDED: 'This item has already been added to the order.',
   ITEM_REMOVED_EARLIER: 'This item was removed earlier. Click on restore to re-add it',
   CANNOT_REMOVE_ALL_ITEMS: 'Consignment cannot have zero entries. Please cancel in case of cancellation',
   UNIT_PRICE_REQUIRED: 'Unit price is required.',
   UNIT_PRICE_INVALID: 'Enter a valid unit price.',
   UNIT_PRICE_MAX: 'Unit price cannot be greater than 999,999,999.',
   REMOVE_ITEM_CONFIRM_TITLE: 'Remove item',
   REMOVE_ITEM_CONFIRM_MESSAGE: 'Are you sure you want to remove this item from the edited order?',
   CANCEL_EDITING_CONFIRM_TITLE: 'Cancel editing',
   CANCEL_EDITING_CONFIRM_MESSAGE: 'Are you sure you want to cancel editing? All changes made on this screen will be discarded.',
   LEAVE_SCREEN_CONFIRM_TITLE: 'Leave screen',
   LEAVE_SCREEN_CONFIRM_MESSAGE: 'Are you sure you want to leave this screen? All changes made on this screen will be discarded.',
   SEND_FOR_APPROVAL_SUCCESS: 'Order changes sent for buyer approval',
   SEND_FOR_APPROVAL_FAILED: 'Failed to send the approval request. Please try again.',

   // Awaiting buyer approval (edit order)
   AWAITING_BUYER_APPROVAL_TITLE: 'Awaiting buyer approval',
   AWAITING_BUYER_APPROVAL_BODY: 'Order changes have been submitted to the buyer for approval.',
   AWAITING_BUYER_APPROVAL_HOLD: 'Order fulfilment is currently on hold until the buyer responds.',
   ORDER_CHANGES_SUBMITTED: 'Order changes submitted',
   ORDER_CHANGES_SUBMITTED_SUBTITLE: 'The following order changes were submitted to the buyer for approval.',
   CHANGE: 'Change',
   VENDOR_COMMENT: 'Vendor comment',
   ADDED_TAG: 'Added',
   REMOVED_TAG: 'Removed',
   ORIGINAL_ORDER_TOTAL: 'Original order total',
   UPDATED_ORDER_TOTAL: 'Updated order total',
   NET_CHANGE: 'Net change',
   ORIGINAL_ORDER_TITLE: 'Original order',
   ORIGINAL_ORDER_BEFORE_CHANGES: 'Original order before submitted changes',
   SHOW_ORIGINAL_ORDER_BEFORE_CHANGES: 'Show the original order before submitted changes',
   APPROVAL_REQUEST_DETAILS: 'Approval request details',
   SENT_TO: 'Sent to',
   SENT_ON: 'Sent on',
   STATUS: 'Status',
   WAITING_FOR_APPROVAL: 'Awaiting response',
   BUYER_NOT_RESPONDED_YET: 'Buyer has not responded yet.',
   BUYER_NOTIFIED_OF_REQUEST_INFO: 'The buyer will be notified of your request via email.',
   WITHDRAW_REQUEST: 'Withdraw request',
   RESEND_APPROVAL_REQUEST: 'Resend approval email',
   APPROVE_ON_BEHALF_OF_BUYER: 'Approve on behalf of buyer',
   AWAITS_EDIT_ORDER_PENDING: 'Please wait while the order changes are submitted for buyer approval.',

   // Withdraw confirmation
   WITHDRAW_CONFIRM_TITLE: 'Withdraw approval request?',
   WITHDRAW_CONFIRM_MESSAGE: 'This will cancel the buyer approval request, revert the order to its previous state, and move the order back to New.',
   WITHDRAW_CONFIRM_ACTION: 'Withdraw request',
   WITHDRAW_REQUEST_SUCCESS: 'Approval request withdrawn',
   WITHDRAW_REQUEST_FAILED: 'Failed to withdraw the approval request. Please try again.',

   // Approve on behalf confirmation
   APPROVE_ON_BEHALF_CONFIRM_TITLE: 'Approve on behalf of buyer?',
   APPROVE_ON_BEHALF_CONFIRM_MESSAGE: 'This will approve the submitted order changes and continue the order fulfillment process.',
   APPROVE_ON_BEHALF_CONFIRM_ACTION: 'Approve on behalf of buyer',
   APPROVE_ON_BEHALF_SUCCESS: 'Order changes approved on behalf of the buyer',
   APPROVE_ON_BEHALF_FAILED: 'Failed to approve the order changes. Please try again.',

   // Resend
   RESEND_APPROVAL_SUCCESS: 'Approval email resent to the buyer',
   RESEND_APPROVAL_FAILED: 'Failed to resend the approval email. Please try again.',

   // Additional shipping cost approval (shipping cost approval banner)
   ADDITIONAL_SHIPPING_COST: 'Additional shipping cost',
   EDIT_SHIPPING_COST: 'Edit shipping cost',
   REMOVE_SHIPPING_COST: 'Remove shipping cost',
   SAVE_AND_RESEND_FOR_APPROVAL: 'Save and resend for approval',
   SHIPPING_COST_HELPER_TEXT: 'Editing the amount will send a new approval email to the customer. Removing it will continue the order to payment.',
   SHIPPING_COST_UPDATE_SUCCESS: 'The additional shipping cost has been updated and a new approval request was sent to the customer.',
   SHIPPING_COST_UPDATE_FAILED: 'Failed to update the additional shipping cost. Please try again.',
   REMOVE_SHIPPING_COST_CONFIRM_TITLE: 'Remove shipping cost?',
   REMOVE_SHIPPING_COST_CONFIRM_MESSAGE: 'This will remove the additional shipping cost from the order and continue the order to payment.',
   REMOVE_SHIPPING_COST_CONFIRM_ACTION: 'Remove shipping cost',
   REMOVE_SHIPPING_COST_SUCCESS: 'The additional shipping cost has been removed and the order is proceeding to payment.',
   REMOVE_SHIPPING_COST_FAILED: 'Failed to remove the additional shipping cost. Please try again.',
}

// Mirrors EDIT_ORDER_UNIT_PRICE_MAX in api/src/constants/order.js — keep the two in step.
export const UNIT_PRICE_MAX = 999999999;

// Mirrors EDIT_APPROVAL_ACTIONS in api/src/constants/order.js — marks a PUT /state call
// as an approve-on-behalf so the backend guard can tell it apart from other transitions
// into PROCESSING.
export const EDIT_APPROVAL_ACTIONS = {
   APPROVE_ON_BEHALF: 'APPROVE_ON_BEHALF'
}

export const CONSIGNMENT_TYPES = {
   RENT: 'RENT',
   PURCHASE: 'PURCHASE',
   SUBSCRIPTION: 'SUBSCRIPTION',
   AFFILIATE_PROGRAM: 'AFFILIATE_PROGRAM',
}

export const SHIPPING_DETAILS = ["Ship to", "From warehouse"]
export const PICKUP_DETAILS = ["Pickup location", "Warehouse", "Pickup contact"]

export const PRICE_PENDING_PREVIOUS_STATES = [RENT_IN_PROGRESS, RENT_RETURN_PENDING] 